import React, { useState } from 'react';
import ReferralsTable from './ReferralsTable';
import styled from 'styled-components';

const referralsList = [
  {
    id: 1,
    user_id: 184478,
    referred_user_id: 225461,
    amount_purchased: 500000,
    purchase_date: '2025-07-28T16:02:01+00:00',
    bonus_given: false,
    amount_given: null,
    created: '2025-08-14T18:28:26+00:00',
    modified: '2025-08-14T18:28:26+00:00',
    referred_user: {
      id: 225461,
      group_id: 3,
      openpay_client_id: null,
      partner_id: null,
      partner_user_id: null,
      email: 'nayrobimata14@gmail.com',
      name: 'Nayrobi montserrat',
      last_name: 'Zamudio mata',
      nick: 'mata38',
      state: null,
      phone: 524531181308,
      dob: null,
      personal_id_number: null,
      provider: null,
      provider_uid: null,
      accept_credit: 0,
      source: 'app',
      website: 'playmoney',
      source_other: null,
      entry_count: 0,
      entries_real_count: 0,
      survivors_entry_count: 0,
      all_entry_count: 0,
      freerolls_count_typeone: 0,
      freerolls_count_typetwo: 0,
      prizes_count: 0,
      referal_count: 0,
      avatar_dir: 'https://storage.googleapis.com/pw-resources/avatars/',
      avatar: 'eb2a9228-c6d1-486f-bf32-a25375a53d4f.jpg',
      summer_code: false,
      oldip: null,
      last_login: '2025-07-25T17:04:12+00:00',
      tutorials_seen: 0,
      active: true,
      tos: true,
      ban_reason: null,
      notified: 0,
      last_notification: null,
      rem_balance_times: null,
      last_rem_balance: null,
      newsletter: true,
      identity_verified: true,
      automatic_cashout: false,
      cashouts_verified: 0,
      suspension_status: 0,
      week: '2025-30',
      doing_registration: false,
      sinsaldo_added: null,
      ambassador: false,
      is_salesman: false,
      activated: false,
      has_old_referrals: false,
      has_vip_referrals: false,
      vip_referral_start: null,
      deletion_request: null,
      created: '2025-07-25T17:04:12+00:00',
      modified: '2025-07-28T16:01:57+00:00',
      full_name: 'Nayrobi montserrat Zamudio mata',
      is_new: false,
    },
  },
  {
    id: 2,
    user_id: 184478,
    referred_user_id: 225466,
    amount_purchased: 500000,
    purchase_date: '2025-07-25T19:43:50+00:00',
    bonus_given: false,
    amount_given: null,
    created: '2025-08-14T18:28:26+00:00',
    modified: '2025-08-14T18:28:26+00:00',
    referred_user: {
      id: 225466,
      group_id: 3,
      openpay_client_id: null,
      partner_id: null,
      partner_user_id: null,
      email: 'jantonioestradamata@gmail.com',
      name: 'Jose Antonio',
      last_name: 'Estrada Mata',
      nick: 'Antest1805',
      state: null,
      phone: 524423352225,
      dob: null,
      personal_id_number: null,
      provider: null,
      provider_uid: null,
      accept_credit: 0,
      source: 'webapp',
      website: 'playmoney',
      source_other: null,
      entry_count: 0,
      entries_real_count: 0,
      survivors_entry_count: 0,
      all_entry_count: 0,
      freerolls_count_typeone: 0,
      freerolls_count_typetwo: 0,
      prizes_count: 0,
      referal_count: 0,
      avatar_dir: null,
      avatar: null,
      summer_code: false,
      oldip: null,
      last_login: '2025-07-25T19:40:23+00:00',
      tutorials_seen: 0,
      active: true,
      tos: true,
      ban_reason: null,
      notified: 0,
      last_notification: null,
      rem_balance_times: null,
      last_rem_balance: null,
      newsletter: false,
      identity_verified: true,
      automatic_cashout: false,
      cashouts_verified: 0,
      suspension_status: 0,
      week: '2025-30',
      doing_registration: false,
      sinsaldo_added: null,
      ambassador: false,
      is_salesman: false,
      activated: false,
      has_old_referrals: false,
      has_vip_referrals: false,
      vip_referral_start: null,
      deletion_request: null,
      created: '2025-07-25T19:37:48+00:00',
      modified: '2025-07-25T19:43:47+00:00',
      full_name: 'Jose Antonio Estrada Mata',
      is_new: false,
    },
  },
  {
    id: 3,
    user_id: 184478,
    referred_user_id: 225492,
    amount_purchased: 500000,
    purchase_date: '2025-07-26T15:14:02+00:00',
    bonus_given: false,
    amount_given: null,
    created: '2025-08-14T18:28:26+00:00',
    modified: '2025-08-14T18:28:26+00:00',
    referred_user: {
      id: 225492,
      group_id: 3,
      openpay_client_id: null,
      partner_id: null,
      partner_user_id: null,
      email: 've13051989@gmail.com',
      name: 'Erik',
      last_name: 'Velasco bolas',
      nick: 'Eriko1989',
      state: null,
      phone: 522228290921,
      dob: null,
      personal_id_number: null,
      provider: null,
      provider_uid: null,
      accept_credit: 0,
      source: 'app',
      website: 'playmoney',
      source_other: null,
      entry_count: 0,
      entries_real_count: 0,
      survivors_entry_count: 0,
      all_entry_count: 0,
      freerolls_count_typeone: 0,
      freerolls_count_typetwo: 0,
      prizes_count: 0,
      referal_count: 0,
      avatar_dir: null,
      avatar: null,
      summer_code: false,
      oldip: null,
      last_login: '2025-07-26T15:04:34+00:00',
      tutorials_seen: 0,
      active: true,
      tos: true,
      ban_reason: null,
      notified: 0,
      last_notification: null,
      rem_balance_times: null,
      last_rem_balance: null,
      newsletter: false,
      identity_verified: true,
      automatic_cashout: false,
      cashouts_verified: 0,
      suspension_status: 0,
      week: '2025-30',
      doing_registration: false,
      sinsaldo_added: null,
      ambassador: false,
      is_salesman: false,
      activated: false,
      has_old_referrals: false,
      has_vip_referrals: false,
      vip_referral_start: null,
      deletion_request: null,
      created: '2025-07-26T15:04:34+00:00',
      modified: '2025-07-26T15:13:59+00:00',
      full_name: 'Erik Velasco bolas',
      is_new: false,
    },
  },
  {
    id: 4,
    user_id: 184478,
    referred_user_id: 225494,
    amount_purchased: 500000,
    purchase_date: '2025-07-26T16:11:14+00:00',
    bonus_given: false,
    amount_given: null,
    created: '2025-08-14T18:28:26+00:00',
    modified: '2025-08-14T18:28:26+00:00',
    referred_user: {
      id: 225494,
      group_id: 3,
      openpay_client_id: null,
      partner_id: null,
      partner_user_id: null,
      email: 'rodriguezheredia98@gmail.com',
      name: 'María Guadalupe',
      last_name: 'Rodríguez Heredia',
      nick: 'Lupitasin',
      state: null,
      phone: 529811215825,
      dob: null,
      personal_id_number: null,
      provider: null,
      provider_uid: null,
      accept_credit: 0,
      source: 'landing-full',
      website: 'playmoney',
      source_other: null,
      entry_count: 0,
      entries_real_count: 0,
      survivors_entry_count: 0,
      all_entry_count: 0,
      freerolls_count_typeone: 0,
      freerolls_count_typetwo: 0,
      prizes_count: 0,
      referal_count: 0,
      avatar_dir: null,
      avatar: null,
      summer_code: false,
      oldip: null,
      last_login: '2025-07-26T16:07:14+00:00',
      tutorials_seen: 0,
      active: true,
      tos: true,
      ban_reason: null,
      notified: 0,
      last_notification: null,
      rem_balance_times: null,
      last_rem_balance: null,
      newsletter: true,
      identity_verified: true,
      automatic_cashout: false,
      cashouts_verified: 0,
      suspension_status: 0,
      week: '2025-30',
      doing_registration: false,
      sinsaldo_added: null,
      ambassador: false,
      is_salesman: false,
      activated: false,
      has_old_referrals: false,
      has_vip_referrals: false,
      vip_referral_start: null,
      deletion_request: null,
      created: '2025-07-26T16:04:34+00:00',
      modified: '2025-07-26T16:11:10+00:00',
      full_name: 'María Guadalupe Rodríguez Heredia',
      is_new: false,
    },
  },
  {
    id: 5,
    user_id: 184478,
    referred_user_id: 225498,
    amount_purchased: 500000,
    purchase_date: '2025-07-28T20:12:09+00:00',
    bonus_given: false,
    amount_given: null,
    created: '2025-08-14T18:28:26+00:00',
    modified: '2025-08-14T18:28:26+00:00',
    referred_user: {
      id: 225498,
      group_id: 3,
      openpay_client_id: null,
      partner_id: null,
      partner_user_id: null,
      email: 'danielkstro@me.com',
      name: 'José Daniel',
      last_name: 'Castro Cruz',
      nick: 'Danielkstro',
      state: null,
      phone: 527712881867,
      dob: null,
      personal_id_number: null,
      provider: 'Apple',
      provider_uid: '001824.231a076be3a648ce9c345246995d2bd3.1700',
      accept_credit: 0,
      source: 'app',
      website: 'playmoney',
      source_other: null,
      entry_count: 0,
      entries_real_count: 0,
      survivors_entry_count: 0,
      all_entry_count: 1,
      freerolls_count_typeone: 0,
      freerolls_count_typetwo: 0,
      prizes_count: 0,
      referal_count: 0,
      avatar_dir: null,
      avatar: null,
      summer_code: false,
      oldip: null,
      last_login: '2025-07-26T18:15:28+00:00',
      tutorials_seen: 0,
      active: true,
      tos: true,
      ban_reason: null,
      notified: 0,
      last_notification: null,
      rem_balance_times: null,
      last_rem_balance: null,
      newsletter: true,
      identity_verified: true,
      automatic_cashout: false,
      cashouts_verified: 0,
      suspension_status: 0,
      week: '2025-30',
      doing_registration: false,
      sinsaldo_added: null,
      ambassador: false,
      is_salesman: false,
      activated: false,
      has_old_referrals: false,
      has_vip_referrals: false,
      vip_referral_start: null,
      deletion_request: null,
      created: '2025-07-26T18:15:28+00:00',
      modified: '2025-07-26T18:50:38+00:00',
      full_name: 'José Daniel Castro Cruz',
      is_new: false,
    },
  },
  {
    id: 6,
    user_id: 184478,
    referred_user_id: 225504,
    amount_purchased: 500000,
    purchase_date: '2025-07-27T02:36:47+00:00',
    bonus_given: false,
    amount_given: null,
    created: '2025-08-14T18:28:26+00:00',
    modified: '2025-08-14T18:28:26+00:00',
    referred_user: {
      id: 225504,
      group_id: 3,
      openpay_client_id: null,
      partner_id: null,
      partner_user_id: null,
      email: 'gabrielgarfias077@gmail.com',
      name: 'Gabriel',
      last_name: 'Garfias',
      nick: '_AddleTbsp',
      state: null,
      phone: 525574702951,
      dob: null,
      personal_id_number: null,
      provider: null,
      provider_uid: null,
      accept_credit: 0,
      source: 'app',
      website: 'playmoney',
      source_other: null,
      entry_count: 0,
      entries_real_count: 0,
      survivors_entry_count: 0,
      all_entry_count: 0,
      freerolls_count_typeone: 0,
      freerolls_count_typetwo: 0,
      prizes_count: 0,
      referal_count: 0,
      avatar_dir: null,
      avatar: null,
      summer_code: false,
      oldip: null,
      last_login: '2025-07-27T02:33:22+00:00',
      tutorials_seen: 0,
      active: false,
      tos: true,
      ban_reason: 'Account deleted by user',
      notified: 0,
      last_notification: null,
      rem_balance_times: null,
      last_rem_balance: null,
      newsletter: false,
      identity_verified: false,
      automatic_cashout: false,
      cashouts_verified: 0,
      suspension_status: 3,
      week: '2025-30',
      doing_registration: false,
      sinsaldo_added: null,
      ambassador: false,
      is_salesman: false,
      activated: false,
      has_old_referrals: false,
      has_vip_referrals: false,
      vip_referral_start: null,
      deletion_request: '2025-07-27T03:02:14+00:00',
      created: '2025-07-27T02:33:22+00:00',
      modified: '2025-07-27T03:02:15+00:00',
      full_name: 'Gabriel Garfias',
      is_new: false,
    },
  },
  {
    id: 7,
    user_id: 184478,
    referred_user_id: 225525,
    amount_purchased: 500000,
    purchase_date: '2025-07-27T19:52:34+00:00',
    bonus_given: false,
    amount_given: null,
    created: '2025-08-14T18:28:26+00:00',
    modified: '2025-08-14T18:28:26+00:00',
    referred_user: {
      id: 225525,
      group_id: 3,
      openpay_client_id: null,
      partner_id: null,
      partner_user_id: null,
      email: 'e_saldana@hotmail.com',
      name: 'Emmanuel',
      last_name: 'Saldana',
      nick: 'BereTeam',
      state: null,
      phone: 525522483362,
      dob: null,
      personal_id_number: null,
      provider: null,
      provider_uid: null,
      accept_credit: 0,
      source: 'app',
      website: 'playmoney',
      source_other: null,
      entry_count: 0,
      entries_real_count: 0,
      survivors_entry_count: 0,
      all_entry_count: 1,
      freerolls_count_typeone: 0,
      freerolls_count_typetwo: 0,
      prizes_count: 0,
      referal_count: 0,
      avatar_dir: null,
      avatar: null,
      summer_code: false,
      oldip: null,
      last_login: '2025-07-27T19:37:09+00:00',
      tutorials_seen: 0,
      active: true,
      tos: true,
      ban_reason: null,
      notified: 0,
      last_notification: null,
      rem_balance_times: null,
      last_rem_balance: null,
      newsletter: true,
      identity_verified: true,
      automatic_cashout: false,
      cashouts_verified: 0,
      suspension_status: 0,
      week: '2025-30',
      doing_registration: false,
      sinsaldo_added: null,
      ambassador: false,
      is_salesman: false,
      activated: false,
      has_old_referrals: false,
      has_vip_referrals: false,
      vip_referral_start: null,
      deletion_request: null,
      created: '2025-07-27T19:37:09+00:00',
      modified: '2025-07-27T19:52:30+00:00',
      full_name: 'Emmanuel Saldana',
      is_new: false,
    },
  },
  {
    id: 8,
    user_id: 184478,
    referred_user_id: 225533,
    amount_purchased: 500000,
    purchase_date: '2025-07-28T02:47:03+00:00',
    bonus_given: false,
    amount_given: null,
    created: '2025-08-14T18:28:26+00:00',
    modified: '2025-08-14T18:28:26+00:00',
    referred_user: {
      id: 225533,
      group_id: 3,
      openpay_client_id: null,
      partner_id: null,
      partner_user_id: null,
      email: 'gruamauro22@gmail.com',
      name: 'Jose Mauricio',
      last_name: 'Zarate pech',
      nick: 'zaratepech',
      state: null,
      phone: 529997658829,
      dob: null,
      personal_id_number: null,
      provider: null,
      provider_uid: null,
      accept_credit: 0,
      source: 'webapp',
      website: 'playmoney',
      source_other: null,
      entry_count: 0,
      entries_real_count: 0,
      survivors_entry_count: 0,
      all_entry_count: 0,
      freerolls_count_typeone: 0,
      freerolls_count_typetwo: 0,
      prizes_count: 0,
      referal_count: 0,
      avatar_dir: null,
      avatar: null,
      summer_code: false,
      oldip: null,
      last_login: '2025-07-28T02:39:52+00:00',
      tutorials_seen: 0,
      active: true,
      tos: true,
      ban_reason: null,
      notified: 0,
      last_notification: null,
      rem_balance_times: null,
      last_rem_balance: null,
      newsletter: true,
      identity_verified: true,
      automatic_cashout: false,
      cashouts_verified: 0,
      suspension_status: 0,
      week: '2025-30',
      doing_registration: false,
      sinsaldo_added: null,
      ambassador: false,
      is_salesman: false,
      activated: false,
      has_old_referrals: false,
      has_vip_referrals: false,
      vip_referral_start: null,
      deletion_request: null,
      created: '2025-07-28T02:29:59+00:00',
      modified: '2025-07-28T02:47:00+00:00',
      full_name: 'Jose Mauricio Zarate pech',
      is_new: false,
    },
  },
  {
    id: 9,
    user_id: 184478,
    referred_user_id: 225536,
    amount_purchased: 500000,
    purchase_date: '2025-07-28T04:16:49+00:00',
    bonus_given: true,
    amount_given: 100000,
    created: '2025-08-14T18:28:26+00:00',
    modified: '2025-08-14T18:28:26+00:00',
    referred_user: {
      id: 225536,
      group_id: 3,
      openpay_client_id: null,
      partner_id: null,
      partner_user_id: null,
      email: 'jannethislasalcantar@gmail.com',
      name: 'Marisa janneth',
      last_name: 'Islas alcantar',
      nick: 'mar78',
      state: null,
      phone: 524451096866,
      dob: null,
      personal_id_number: null,
      provider: null,
      provider_uid: null,
      accept_credit: 0,
      source: 'landing-full',
      website: 'playmoney',
      source_other: null,
      entry_count: 0,
      entries_real_count: 0,
      survivors_entry_count: 0,
      all_entry_count: 0,
      freerolls_count_typeone: 0,
      freerolls_count_typetwo: 0,
      prizes_count: 0,
      referal_count: 0,
      avatar_dir: 'https://storage.googleapis.com/pw-resources/avatars/',
      avatar: '16638611-ac05-47da-a147-8a10830c2776.jpg',
      summer_code: false,
      oldip: null,
      last_login: '2025-07-28T04:08:54+00:00',
      tutorials_seen: 0,
      active: true,
      tos: true,
      ban_reason: null,
      notified: 0,
      last_notification: null,
      rem_balance_times: null,
      last_rem_balance: null,
      newsletter: false,
      identity_verified: true,
      automatic_cashout: false,
      cashouts_verified: 0,
      suspension_status: 0,
      week: '2025-30',
      doing_registration: false,
      sinsaldo_added: null,
      ambassador: false,
      is_salesman: false,
      activated: false,
      has_old_referrals: false,
      has_vip_referrals: false,
      vip_referral_start: null,
      deletion_request: null,
      created: '2025-07-28T04:03:02+00:00',
      modified: '2025-07-28T04:16:05+00:00',
      full_name: 'Marisa janneth Islas alcantar',
      is_new: false,
    },
  },
  {
    id: 10,
    user_id: 184478,
    referred_user_id: 225544,
    amount_purchased: 500000,
    purchase_date: '2025-07-28T08:47:45+00:00',
    bonus_given: true,
    amount_given: 100000,
    created: '2025-08-14T18:28:26+00:00',
    modified: '2025-08-14T18:28:26+00:00',
    referred_user: {
      id: 225544,
      group_id: 3,
      openpay_client_id: null,
      partner_id: null,
      partner_user_id: null,
      email: 'armandohoyos66t@gmail.com',
      name: 'Valeria',
      last_name: 'Flores',
      nick: 'armando66t',
      state: null,
      phone: 526624114329,
      dob: null,
      personal_id_number: null,
      provider: null,
      provider_uid: null,
      accept_credit: 0,
      source: 'app',
      website: 'playmoney',
      source_other: null,
      entry_count: 0,
      entries_real_count: 0,
      survivors_entry_count: 0,
      all_entry_count: 0,
      freerolls_count_typeone: 0,
      freerolls_count_typetwo: 0,
      prizes_count: 0,
      referal_count: 0,
      avatar_dir: null,
      avatar: null,
      summer_code: false,
      oldip: null,
      last_login: '2025-07-28T08:44:03+00:00',
      tutorials_seen: 0,
      active: true,
      tos: true,
      ban_reason: null,
      notified: 0,
      last_notification: null,
      rem_balance_times: null,
      last_rem_balance: null,
      newsletter: true,
      identity_verified: true,
      automatic_cashout: false,
      cashouts_verified: 0,
      suspension_status: 0,
      week: '2025-31',
      doing_registration: false,
      sinsaldo_added: null,
      ambassador: false,
      is_salesman: false,
      activated: false,
      has_old_referrals: false,
      has_vip_referrals: false,
      vip_referral_start: null,
      deletion_request: null,
      created: '2025-07-28T08:44:03+00:00',
      modified: '2025-07-28T08:46:25+00:00',
      full_name: 'Valeria Flores',
      is_new: false,
    },
  },
  {
    id: 11,
    user_id: 184478,
    referred_user_id: 225550,
    amount_purchased: 500000,
    purchase_date: '2025-07-28T16:58:59+00:00',
    bonus_given: true,
    amount_given: 100000,
    created: '2025-08-14T18:28:26+00:00',
    modified: '2025-08-14T18:28:26+00:00',
    referred_user: {
      id: 225550,
      group_id: 3,
      openpay_client_id: null,
      partner_id: null,
      partner_user_id: null,
      email: 'fabiolaoriv@hotmail.com',
      name: 'Fabiola',
      last_name: 'Olvera rivas',
      nick: 'FabiolaOR',
      state: null,
      phone: 528115312171,
      dob: null,
      personal_id_number: null,
      provider: null,
      provider_uid: null,
      accept_credit: 0,
      source: 'app',
      website: 'playmoney',
      source_other: null,
      entry_count: 0,
      entries_real_count: 0,
      survivors_entry_count: 0,
      all_entry_count: 1,
      freerolls_count_typeone: 0,
      freerolls_count_typetwo: 0,
      prizes_count: 0,
      referal_count: 0,
      avatar_dir: null,
      avatar: null,
      summer_code: false,
      oldip: null,
      last_login: '2025-07-28T16:53:03+00:00',
      tutorials_seen: 0,
      active: true,
      tos: true,
      ban_reason: null,
      notified: 0,
      last_notification: null,
      rem_balance_times: null,
      last_rem_balance: null,
      newsletter: false,
      identity_verified: true,
      automatic_cashout: false,
      cashouts_verified: 0,
      suspension_status: 0,
      week: '2025-31',
      doing_registration: false,
      sinsaldo_added: null,
      ambassador: false,
      is_salesman: false,
      activated: false,
      has_old_referrals: false,
      has_vip_referrals: false,
      vip_referral_start: null,
      deletion_request: null,
      created: '2025-07-28T16:53:03+00:00',
      modified: '2025-07-28T16:58:55+00:00',
      full_name: 'Fabiola Olvera rivas',
      is_new: false,
    },
  },
  {
    id: 12,
    user_id: 184478,
    referred_user_id: 225562,
    amount_purchased: 500000,
    purchase_date: '2025-07-28T23:54:03+00:00',
    bonus_given: true,
    amount_given: 100000,
    created: '2025-08-14T18:28:26+00:00',
    modified: '2025-08-14T18:28:26+00:00',
    referred_user: {
      id: 225562,
      group_id: 3,
      openpay_client_id: null,
      partner_id: null,
      partner_user_id: null,
      email: 'crucasenrique@gmail.com',
      name: 'ENRIQUE',
      last_name: 'CRUZ CASTELLANOS',
      nick: 'Enrique36',
      state: null,
      phone: 527681038423,
      dob: null,
      personal_id_number: null,
      provider: null,
      provider_uid: null,
      accept_credit: 0,
      source: 'webapp',
      website: 'playmoney',
      source_other: null,
      entry_count: 0,
      entries_real_count: 0,
      survivors_entry_count: 0,
      all_entry_count: 0,
      freerolls_count_typeone: 0,
      freerolls_count_typetwo: 0,
      prizes_count: 0,
      referal_count: 0,
      avatar_dir: null,
      avatar: null,
      summer_code: false,
      oldip: null,
      last_login: '2025-07-28T23:39:50+00:00',
      tutorials_seen: 0,
      active: true,
      tos: true,
      ban_reason: null,
      notified: 0,
      last_notification: null,
      rem_balance_times: null,
      last_rem_balance: null,
      newsletter: true,
      identity_verified: true,
      automatic_cashout: false,
      cashouts_verified: 4,
      suspension_status: 0,
      week: '2025-31',
      doing_registration: false,
      sinsaldo_added: null,
      ambassador: false,
      is_salesman: false,
      activated: false,
      has_old_referrals: false,
      has_vip_referrals: false,
      vip_referral_start: null,
      deletion_request: null,
      created: '2025-07-28T23:39:51+00:00',
      modified: '2025-07-28T23:54:00+00:00',
      full_name: 'ENRIQUE CRUZ CASTELLANOS',
      is_new: false,
    },
  },
  {
    id: 13,
    user_id: 184478,
    referred_user_id: 225563,
    amount_purchased: 500000,
    purchase_date: '2025-07-29T01:11:03+00:00',
    bonus_given: true,
    amount_given: 100000,
    created: '2025-08-14T18:28:26+00:00',
    modified: '2025-08-14T18:28:26+00:00',
    referred_user: {
      id: 225563,
      group_id: 3,
      openpay_client_id: null,
      partner_id: null,
      partner_user_id: null,
      email: 'nicolasjj1981@gmail.com',
      name: 'JESUS',
      last_name: 'DE LA CRUZ GUTIERREZ',
      nick: 200181,
      state: null,
      phone: 524442164776,
      dob: null,
      personal_id_number: null,
      provider: null,
      provider_uid: null,
      accept_credit: 0,
      source: 'webapp',
      website: 'playmoney',
      source_other: null,
      entry_count: 0,
      entries_real_count: 0,
      survivors_entry_count: 0,
      all_entry_count: 0,
      freerolls_count_typeone: 0,
      freerolls_count_typetwo: 0,
      prizes_count: 0,
      referal_count: 0,
      avatar_dir: null,
      avatar: null,
      summer_code: false,
      oldip: null,
      last_login: '2025-07-29T01:45:52+00:00',
      tutorials_seen: 0,
      active: true,
      tos: true,
      ban_reason: null,
      notified: 0,
      last_notification: null,
      rem_balance_times: null,
      last_rem_balance: null,
      newsletter: true,
      identity_verified: true,
      automatic_cashout: false,
      cashouts_verified: 4,
      suspension_status: 0,
      week: '2025-31',
      doing_registration: false,
      sinsaldo_added: null,
      ambassador: false,
      is_salesman: false,
      activated: false,
      has_old_referrals: false,
      has_vip_referrals: false,
      vip_referral_start: null,
      deletion_request: null,
      created: '2025-07-29T01:01:46+00:00',
      modified: '2025-07-29T05:38:20+00:00',
      full_name: 'JESUS DE LA CRUZ GUTIERREZ',
      is_new: false,
    },
  },
  {
    id: 14,
    user_id: 184478,
    referred_user_id: 225564,
    amount_purchased: 500000,
    purchase_date: '2025-07-29T03:03:12+00:00',
    bonus_given: true,
    amount_given: 100000,
    created: '2025-08-14T18:28:26+00:00',
    modified: '2025-08-14T18:28:26+00:00',
    referred_user: {
      id: 225564,
      group_id: 3,
      openpay_client_id: null,
      partner_id: null,
      partner_user_id: null,
      email: 'claudiaelisatrujillo@gmail.com',
      name: 'Claudia Elisa',
      last_name: 'Trujillo Gonzalez',
      nick: 'Asile73',
      state: null,
      phone: 526141774988,
      dob: null,
      personal_id_number: null,
      provider: null,
      provider_uid: null,
      accept_credit: 0,
      source: 'webapp',
      website: 'playmoney',
      source_other: null,
      entry_count: 0,
      entries_real_count: 0,
      survivors_entry_count: 0,
      all_entry_count: 0,
      freerolls_count_typeone: 0,
      freerolls_count_typetwo: 0,
      prizes_count: 0,
      referal_count: 0,
      avatar_dir: null,
      avatar: null,
      summer_code: false,
      oldip: null,
      last_login: '2025-07-29T02:57:32+00:00',
      tutorials_seen: 0,
      active: true,
      tos: true,
      ban_reason: null,
      notified: 0,
      last_notification: null,
      rem_balance_times: null,
      last_rem_balance: null,
      newsletter: true,
      identity_verified: true,
      automatic_cashout: false,
      cashouts_verified: 0,
      suspension_status: 0,
      week: '2025-31',
      doing_registration: false,
      sinsaldo_added: null,
      ambassador: false,
      is_salesman: false,
      activated: false,
      has_old_referrals: false,
      has_vip_referrals: false,
      vip_referral_start: null,
      deletion_request: null,
      created: '2025-07-29T02:57:35+00:00',
      modified: '2025-07-29T03:03:09+00:00',
      full_name: 'Claudia Elisa Trujillo Gonzalez',
      is_new: false,
    },
  },
  {
    id: 15,
    user_id: 184478,
    referred_user_id: 225566,
    amount_purchased: 500000,
    purchase_date: '2025-07-29T03:33:19+00:00',
    bonus_given: true,
    amount_given: 100000,
    created: '2025-08-14T18:28:26+00:00',
    modified: '2025-08-14T18:28:26+00:00',
    referred_user: {
      id: 225566,
      group_id: 3,
      openpay_client_id: null,
      partner_id: null,
      partner_user_id: null,
      email: 'aabud74@gmail.com',
      name: 'Alberto',
      last_name: 'Abud Hatari',
      nick: 'Aguila55',
      state: null,
      phone: 525576956426,
      dob: null,
      personal_id_number: null,
      provider: null,
      provider_uid: null,
      accept_credit: 0,
      source: 'landing-full',
      website: 'playmoney',
      source_other: null,
      entry_count: 0,
      entries_real_count: 0,
      survivors_entry_count: 0,
      all_entry_count: 0,
      freerolls_count_typeone: 0,
      freerolls_count_typetwo: 0,
      prizes_count: 0,
      referal_count: 0,
      avatar_dir: null,
      avatar: null,
      summer_code: false,
      oldip: null,
      last_login: '2025-07-29T03:35:09+00:00',
      tutorials_seen: 0,
      active: true,
      tos: true,
      ban_reason: null,
      notified: 0,
      last_notification: null,
      rem_balance_times: null,
      last_rem_balance: null,
      newsletter: false,
      identity_verified: true,
      automatic_cashout: false,
      cashouts_verified: 0,
      suspension_status: 0,
      week: '2025-31',
      doing_registration: false,
      sinsaldo_added: null,
      ambassador: false,
      is_salesman: false,
      activated: false,
      has_old_referrals: false,
      has_vip_referrals: false,
      vip_referral_start: null,
      deletion_request: null,
      created: '2025-07-29T03:26:16+00:00',
      modified: '2025-07-29T03:35:09+00:00',
      full_name: 'Alberto Abud Hatari',
      is_new: false,
    },
  },
];

export const InvitedReferralList2025 = (props) => {
  const [nick, setNick] = useState('')
  
  const referralFiltered = props.referralsList.filter(referral => {

    const userNick = String(referral?.referred_user?.nick);
    const searchTerm = nick?.toLowerCase();
    
    // Si no hay nick o término de búsqueda, no incluir en resultados
    if (!userNick || !searchTerm) return true;
    
    return userNick?.toLowerCase()?.includes(searchTerm);
  })
  

  return (
    <Box>
      <Input
        placeholder='Buscar por nick'
        value={nick}
        onChange={(e) => {

          console.log('e.target.value', e.target.value)
          setNick(e.target.value)
        }}
      />
      <ReferralsTable
        referrals={referralFiltered}
        onActionButton={props.onActionButton}
      />
    </Box>
  );
};


const Box = styled.div`
  width: 100%;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  background-color: #181818;
  border-radius: 5px;
  color: #ffffff;
`;
